import { Component, Input, input } from '@angular/core';
import { ICardColor } from '../../models/lab-dip/card-color.interface';

@Component({
  selector: 'app-card-color',
  templateUrl: './card-color.component.html',
  styleUrl: './card-color.component.scss',
})
export class CardColorComponent {
  @Input() canEdit = false;
  @Input() public color: ICardColor | null = null;
}
